import fetcher from 'features/shared/utils/fetcher'

async function putTermsConditions(value: number ) {
  return await fetcher.put(
    `/accept/terms-conditions/service/${value}`
  )
}

export default putTermsConditions
